export default __webpack_public_path__ + "static/media/da__android.56eac495.svg";